const initialState = {};
const globeParams = (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_GLOBE_PARAMS":
      return { ...state, ...action.data };

    default:
      return { ...state };
  }
};
export default globeParams;
